<template>
	<div>
		<d-modal
			v-cloak
			name="docs"
			popup-title="Документы"
			size="wide"
		>
			<p class="d-modal__text p1">
				<slot name="docs"></slot>
			</p>
			<br>
		</d-modal>

		<d-modal
			v-cloak
			name="archive"
			popup-title="Архив"
			size="wide"
		>
			<p class="d-modal__text p1">
				<slot name="archive"></slot>
			</p>
			<br>
		</d-modal>
	</div>
</template>

<script>
	export default {
		name: 'LoansDocs'
	}
</script>
